export const aiReasonVerdictMap = {
  approved: 'Approved',
  rejected: 'Rejected'
};
